module.exports = __webpack_public_path__ + "static/media/support1.45e690d7.png";